import script from "./ParamsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ParamsModal.vue?vue&type=script&setup=true&lang=js"

import "./ParamsModal.vue?vue&type=style&index=0&id=b3bf917e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3bf917e"]])

export default __exports__